import { render, staticRenderFns } from "./tree-select.vue?vue&type=template&id=dd9987fa&scoped=true&"
import script from "./tree-select.vue?vue&type=script&lang=tsx&"
export * from "./tree-select.vue?vue&type=script&lang=tsx&"
import style0 from "./tree-select.vue?vue&type=style&index=0&id=dd9987fa&prod&lang=scss&scoped=true&"
import style1 from "./tree-select.vue?vue&type=style&index=1&id=dd9987fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9987fa",
  null
  
)

export default component.exports